export default __webpack_public_path__ + "static/media/logo-litmusBlox.0076dcb6.svg";